module.exports = __webpack_public_path__ + "img/rightpic.8b735a88.png";